
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.765 4.25a.75.75 0 00-.249.042 1.893 1.893 0 00-.946 2.84c.02.03.043.06.068.087l5.522 6.074v4.277a.75.75 0 00.3.6l4.57 3.43a.75.75 0 001.2-.6v-7.712l5.518-6.07a.761.761 0 00.068-.086 1.893 1.893 0 00-.946-2.84.75.75 0 00-.248-.042H4.765zm8.965 8.799a.748.748 0 01.194-.553l5.667-6.234a.394.394 0 00-.132-.512H4.927a.393.393 0 00-.132.512l5.633 6.196a.748.748 0 01.232.542v4.195l3.07 2.305v-6.451z"}})])
          )
        }
      }
    